module.exports = __webpack_public_path__ + "static/energy_6-63b4ba2ddb5538863d34e2b516ab0aa0.jpg";